import React, { useState, useEffect } from 'react';
import { gql, useQuery, useLazyQuery, useMutation } from '@apollo/client';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import ButtonBase from '@material-ui/core/ButtonBase';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import DateBanner from './DateBanner.jsx';
// import NotificationIcon from '../icons/NotificationIcon.jsx';
import Search from './Search.jsx';
import {
  GET_USER_CONFIG,
  GET_USER_CONFIG_ID,
  ADD_USER_CONFIG,
  UPDATE_USER_CONFIG,
  REMOVE_USER_CONFIG,
} from '../util/schema';
import { useCookies } from 'react-cookie';
import getNameFromToken from '../util/jwtToken';

const drawerWidth = 260;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
    boxShadow: 'none',
    position: 'fixed',
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  banner: {
    marginRight: theme.spacing(2),
  },
  badge: {
    backgroundColor: theme.palette.warning.light,
  },
  divider: {
    borderLeft: `1px solid ${theme.palette.neutral.main}`,
    height: '2em',
    marginLeft: '0.3em',
  },
  profile: {
    padding: '5px 10px 5px 10px',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '1.3em',
    flexShrink: 0,
  },
}));

const Topbar = ({
  handleDrawerToggle,
  apiToken,
  setApiToken,
  setColorTheme,
  isMobile,
  ...props
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [cookies, setCookie, removeCookie] = useCookies(['name']);
  const [userName, setuserName] = useState(cookies.username);
  const [UserID, setUserID] = useState(1);
  const [newDataFlag, setnewDataFlag] = useState(false);
  const [userConfigInput, setuserConfigInput] = useState();
  const [mode, setMode] = useState(false);
  const [filters, setFilters] = useState([]);

  const queryUserConfig = (data) => {
    if (data == null) {
      setnewDataFlag(true);
    } else {
      setUserID(data.userConfigData.User_ID);
      setnewDataFlag(false);
      const obj = JSON.parse(data.userConfigData.Settings);
      if (obj.Value.filters) {
        try {
          const filters = JSON.parse(obj.Value.filters);
          setFilters(filters);
        } catch (err) {
          console.log('error', err);
        }
      }
      if (props.mode) {
        try {
          setColorTheme('dark');
        } catch (err) {
          console.log('error', err);
        }
      }
      return obj;
    }
  };

  const queryErrorUserConfig = ({ graphQLErrors, networkError }) => {
    console.log(graphQLErrors);
    console.log(networkError);
    setnewDataFlag(true);
  };

  const [
    fetchUserConfig,
    { data: userData, loading: userDataLoading, error: userDataError, fetchMore },
  ] = useLazyQuery(GET_USER_CONFIG, {
    variables: { userconfigName: userName },
    notifyOnNetworkStatusChange: true,
    onCompleted: queryUserConfig,
    onError: queryErrorUserConfig,
  });

  const [
    addUserConfig,
    { data: userDataadd, loading: userDataLoadingadd, error: userDataErroradd },
  ] = useMutation(ADD_USER_CONFIG, {
    notifyOnNetworkStatusChange: true,
    onError: queryErrorUserConfig,
  });

  const [
    updateUserConfig,
    { data: userDataupdate, loading: userDataLoadingupdate, error: userDataErrorupdate },
  ] = useMutation(UPDATE_USER_CONFIG, {
    notifyOnNetworkStatusChange: true,
    onError: queryErrorUserConfig,
  });

  useEffect(() => {
    let ClientName = getNameFromToken(apiToken);
    setuserName(ClientName);
    fetchUserConfig();
  }, []);

  const toolbarBackground = theme.palette.type === 'dark' ? '#1f1f1f' : '#ffffff';
  const toolbarForeground = theme.palette.type === 'dark' ? '#ffffff' : '#43425d';

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTheme = () => {
    handleClose();
    const newTheme = theme.palette.type === 'dark' ? 'light' : 'dark';
    if (newDataFlag) {
      let input = {
        settings: {
          darkmode: newTheme === 'dark' ? true : false,
        },
      };
      addUserConfig({ variables: { userConfigInput: input } });
    } else {
      if (filters.length <= 0) {
        let input = {
          settings: {
            darkmode: newTheme === 'dark' ? true : false,
          },
        };
        updateUserConfig({ variables: { userConfigInput: input } });
      } else {
        let input = {
          settings: {
            darkmode: newTheme === 'dark' ? true : false,
            filters: JSON.stringify(filters),
          },
        };
        updateUserConfig({ variables: { userConfigInput: input } });
      }
    }
    setColorTheme(newTheme);
    window.location.reload();
  };

  const handleLogout = () => {
    handleClose();
    setColorTheme('light');
    setApiToken(null);
  };

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar style={{ backgroundColor: toolbarBackground, color: toolbarForeground }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            className={classes.menuButton}
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
          <div>
            <Search isMobile={isMobile} />
          </div>
          <div className={classes.grow} />
          {isMobile ? (
            <div />
          ) : (
            <Hidden smDown implementation="css">
              <DateBanner className={classes.banner} />
            </Hidden>
          )}
          {/* TODO: The Following code snippet is required for the next release */}
          {/* <IconButton>
          <Badge badgeContent={1} variant="dot" overlap="circle" classes={{ badge: classes.badge }}>
            <NotificationIcon style={{ fill: theme.palette.neutral.main }} />
          </Badge>
        </IconButton> */}
          {!isMobile && (
            <>
              <div className={classes.divider} />
              <ButtonBase
                className={classes.profile}
                aria-controls="profile-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                <Typography>{getNameFromToken(apiToken)}</Typography>
                <ExpandMoreIcon
                  style={
                    !anchorEl
                      ? { fill: theme.palette.neutral.main, marginRight: theme.spacing(0.5) }
                      : { display: 'none' }
                  }
                />
                <ExpandLessIcon
                  style={
                    anchorEl
                      ? { fill: theme.palette.neutral.main, marginRight: theme.spacing(0.5) }
                      : { display: 'none' }
                  }
                />
                <Avatar />
              </ButtonBase>
              <Menu
                id="profile-menu"
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {/* TODO:The Following code snippet is required for the next release */}
                {/* <MenuItem onClick={handleClose}>Account Settings</MenuItem> */}
                <MenuItem onClick={handleTheme}>
                  {theme.palette.type === 'dark' ? 'Light Mode' : 'Dark Mode'}
                </MenuItem>
                {/* <MenuItem onClick={handleClose}>Feedback</MenuItem> */}
                <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
              </Menu>
            </>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Topbar;
